// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card__252ST","Card--grey":"Card--grey__3dQZF","Card--grey20":"Card--grey20__3fLMX","Card--small":"Card--small__3d3xY"};